<template>
    <div>
    <el-col :span="12">
      <div class="search">
        <el-col :span="20">
        <el-input v-model="formData.keyword" placeholder="请输入关键字"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="searchExhibition()">搜索</el-button>
      </el-col>
      </div>
      
    </el-col>
    <el-table :data="tableData" style="width: 100%" height="690" border>
      <el-table-column fixed prop="title" label="展会名" width="200" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="img" label="图片" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">
        <el-image 
    style="width: 30px; height: 30px"
    :src="scope.row.img" 
    :preview-src-list="scope.row.img">
  </el-image>
      </template></el-table-column>
      <el-table-column prop="author" label="作者" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="date" label="展会时间" width="200" :show-overflow-tooltip="true"></el-table-column>
      
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="formData.page"
      :page-sizes="[20,60,100,140]"
      :page-size="formData.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
    ></el-pagination>
  </div>
</template>

<script>
export default {
    name:"Exhibition",
    data(){
        return {
            formData: {
        keyword: "",
        startDate: "",
        endDate: "",
        page: 1,
        limit: 20
      },
      count: 0,
      tableData: [],
        }
    },
    methods:{
        SearchExhibition() {
      let formData = this.formData;
      this.$http
        .post("/v2/SearchExhibition", { formData })
        .then(res => {
          console.log(res.data);
          this.tableData = res.data;
         
          
          this.count = res.count;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSizeChange(val) {
      this.formData.limit = val;
      this.SearchExhibition();
    },
    handleCurrentChange(val) {
      this.formData.page = val;
      this.SearchExhibition();
    }
    },
    created(){
        this.SearchExhibition()
    },
    mounted(){

    }
}
</script>

<style scoped>

</style>